import { render, staticRenderFns } from "./AppDateField.vue?vue&type=template&id=a6f1bf50&"
import script from "./AppDateField.vue?vue&type=script&lang=js&"
export * from "./AppDateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDatePicker,VMenu})
